"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = undefined;

var _client = require("./client");

var createClient = exports.createClient = _client.create;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.87/js/index.js
// module id = 399
// module chunks = 0